import {ActionEnum} from "../action.enum";
import {ChecklistEntry} from "../../models/checklist/checklist-entry-model";

export namespace ChecklistTemplateEntryConvertToTableEntryAction {

  export class ToTableRowInit {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_TABLE_ROW_CONVERSION_TO_TABLE_ROW_INIT;
    constructor (public targetEntryId: string) {}
  }

  export class ConvertToTableEntry {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_TABLE_ROW_CONVERSION_TO_TABLE_ROW_CONVERT;

    constructor(public selectedEntryIds: string[]) {
    }
  }

  export class ConvertToTableReset {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_TABLE_ROW_CONVERSION_TO_TABLE_ROW_RESET;
  }

  export class ToEntryInit {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_TABLE_ROW_CONVERSION_TO_ENTRY_INIT;
    constructor (public targetEntryId: string) {}
  }

  export class ConvertToEntry {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_TABLE_ROW_CONVERSION_TO_ENTRY_CONVERT;

    constructor(public selectedEntryIds: string[]) {
    }
  }

  export class ConvertToEntryReset {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_TABLE_ROW_CONVERSION_TO_ENTRY_RESET;
  }


  export class EntryReFetchNeeded {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_TABLE_ROW_CONVERSION_REFETCH_ENTRY;
  }




}
